var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWorksImage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 556.755,
    height: 441.202,
    viewBox: "0 0 556.755 441.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shutterstock_1497621995_Image_minify",
    x: 0,
    y: 0,
    width: 556.755,
    height: 441.202,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#333",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(-6021 1666.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(6058 -1634)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -37, -32.5)",
    filter: "url(#shutterstock_1497621995_Image_minify)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shutterstock_1497621995_Image_minify-2",
    "data-name": "shutterstock_1497621995_Image_minify",
    width: 481.755,
    height: 366.202,
    rx: 16,
    transform: "translate(37.5 32.5)",
    fill: "#fff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(47.001 70.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Browse_trusted_stylist_by_skills_reviews_and_price._Chat_with_them_to_confirm_the_details",
    "data-name": "Browse trusted stylist by skills, reviews and price. Chat with them to confirm the details",
    transform: "translate(13.293 229.084)",
    fill: "#4b4d4e",
    fontSize: 18,
    fontFamily: "YuGothic-Regular, Yu Gothic",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Browse trusted stylist by skills, reviews and"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29
  }, "price. Chat with them to confirm the details")), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(24.293 173.353)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Choose_your_stylist",
    "data-name": "Choose your stylist",
    transform: "translate(29.062 25.731)",
    fill: "#4b4d4e",
    fontSize: 34,
    fontFamily: "YuGothic-Bold, Yu Gothic",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Choose your stylist")), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(-5 -1.298)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 14.531,
    cy: 14.531,
    r: 14.531,
    transform: "translate(0 0.03)",
    fill: "#2597f6"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(9 21.029)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(59.498 -31.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M233.3,321.364a16.578,16.578,0,1,1,0-33.157H384.186a16.578,16.578,0,1,1,0,33.157Z",
    transform: "translate(-216.72 -288.207)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M240.136,297.207a14.416,14.416,0,1,0,0,28.832H391.023a14.416,14.416,0,1,0,0-28.832Z",
    transform: "translate(-223.558 -295.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 0.481,
    height: 28.832,
    transform: "translate(61.869 2.162)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 0.481,
    height: 28.832,
    transform: "translate(121.695 2.162)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 59.346,
    height: 28.832,
    transform: "translate(62.349 2.162)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M261.085,206.815a8.817,8.817,0,1,0,8.817,8.817,8.817,8.817,0,0,0-8.817-8.817Zm0,2.645a2.645,2.645,0,1,1-2.645,2.645,2.645,2.645,0,0,1,2.645-2.645Zm0,12.734a6.423,6.423,0,0,1-5.29-2.823c.042-1.763,3.527-2.734,5.29-2.734s5.248.971,5.29,2.734A6.434,6.434,0,0,1,261.085,222.194Z",
    transform: "translate(-169.036 -199.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M605.517,206.815a8.817,8.817,0,1,0,8.817,8.817,8.817,8.817,0,0,0-8.817-8.817Zm0,2.645a2.645,2.645,0,1,1-2.645,2.645A2.645,2.645,0,0,1,605.517,209.46Zm0,12.734a6.424,6.424,0,0,1-5.29-2.823c.042-1.763,3.527-2.734,5.29-2.734s5.248.971,5.29,2.734A6.434,6.434,0,0,1,605.517,222.194Z",
    transform: "translate(-573.296 -199.027)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M605.517,206.815a8.817,8.817,0,1,0,8.817,8.817,8.817,8.817,0,0,0-8.817-8.817Zm0,2.645a2.645,2.645,0,1,1-2.645,2.645A2.645,2.645,0,0,1,605.517,209.46Zm0,12.734a6.424,6.424,0,0,1-5.29-2.823c.042-1.763,3.527-2.734,5.29-2.734s5.248.971,5.29,2.734A6.434,6.434,0,0,1,605.517,222.194Z",
    transform: "translate(-453.697 -199.027)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 20.573,
    height: 20.573,
    rx: 6,
    transform: "translate(81.763 45.24)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 49.39,
    cy: 6.613,
    rx: 49.39,
    ry: 6.613,
    transform: "translate(170.81 171.848)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 20.573,
    height: 20.573,
    rx: 6,
    transform: "translate(141.535 45.174)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 14.988,
    height: 14.988,
    transform: "translate(144.474 48.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M248.869,206.152l-2.6-3.343,1.511-1.176,1.231,1.582,4.158-4.389,1.391,1.317Z",
    transform: "translate(-157.785 -147.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M420.869,206.152l-2.6-3.343,1.511-1.176,1.231,1.582,4.158-4.389,1.391,1.317Z",
    transform: "translate(-269.915 -147.432)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 20.573,
    height: 20.573,
    rx: 6,
    transform: "translate(21.936 45.174)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 14.988,
    height: 14.988,
    transform: "translate(24.875 48.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M420.869,206.152l-2.6-3.343,1.511-1.176,1.231,1.582,4.158-4.389,1.391,1.317Z",
    transform: "translate(-389.514 -147.432)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(176.008 9.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M328.357,365.2h-4.842l-2.3-18.676h7.146Z",
    transform: "translate(-250.87 -201.031)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M310.478,387.355h9.338v5.878H304.6A5.878,5.878,0,0,1,310.478,387.355Z",
    transform: "translate(-241.294 -224.567)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M211.562,365.2H206.72l-2.3-18.676h7.146Z",
    transform: "translate(-183.543 -201.031)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M193.686,387.355h9.338v5.878H187.806a5.878,5.878,0,0,1,5.878-5.878Z",
    transform: "translate(-173.967 -224.567)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M487.471,222.417V220.3A13.659,13.659,0,0,1,501.13,206.64h0A13.659,13.659,0,0,1,514.789,220.3v2.118a9.846,9.846,0,0,1-9.846,9.846h-7.625a9.846,9.846,0,0,1-9.846-9.846Z",
    transform: "translate(-443.279 -196.781)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 10.403,
    cy: 10.403,
    r: 10.403,
    transform: "translate(47.449 15.407)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M384.4,327.234a3.972,3.972,0,0,1,6.048.711l8.917-1.687,2.347,5.169-12.627,2.2a3.993,3.993,0,0,1-4.686-6.4Z",
    transform: "translate(-383.132 -265.673)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M445.844,283.547l.116.177-14.622,9.633-24.675,7.879a1.486,1.486,0,0,0-1.022,1.583l.538,4.636a1.483,1.483,0,0,0,1.783,1.278l23.223-4.978a8.387,8.387,0,0,0,3.123-1.375l16.426-11.688a4.225,4.225,0,1,0-4.776-6.969Z",
    transform: "translate(-396.102 -240.783)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M482.365,436.249a1.914,1.914,0,0,1-1.753-1.144l-22.2-54.85a.635.635,0,0,0-1.19.067l-18.11,53.4a1.906,1.906,0,0,1-2.491,1.224l-6.073-2.278a1.9,1.9,0,0,1-1.227-1.569c-2.732-23.8,21.092-83.873,21.333-84.477l.067-.167,21.718,4.8.045.049c8.665,9.453,15.787,69.072,17.126,80.927a1.9,1.9,0,0,1-1.258,2.01l-5.36,1.9a1.889,1.889,0,0,1-.63.108Z",
    transform: "translate(-409.634 -277.378)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M492.292,311.338c-5.262,0-11.128-1.049-12.934-5.379l-.042-.1.056-.092c1.425-2.339,3.309-6.328,2.3-7.077-1.994-1.475-2.963-3.9-2.877-7.211A17.374,17.374,0,0,1,490.976,275.6h0a54.093,54.093,0,0,1,6.041-1.555,10.284,10.284,0,0,1,8.527,2.106,10.388,10.388,0,0,1,3.852,7.992c.073,7.678-1.108,18.375-7.164,25.716a1.884,1.884,0,0,1-1.115.648,51.773,51.773,0,0,1-8.825.826Z",
    transform: "translate(-438.273 -235.522)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M505.845,349.765a4.047,4.047,0,0,1,4.946-2.823,3.99,3.99,0,0,1,.613.227l6.771-6.162,4.709,3.172-9.683,8.569a4.041,4.041,0,0,1-4.58,1.943,3.979,3.979,0,0,1-2.777-4.926Z",
    transform: "translate(-453.783 -274.238)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M526.4,316.594a1.9,1.9,0,0,1-1.206-.432l-2.67-2.182a1.906,1.906,0,0,1,.046-2.988l11.2-8.589a.637.637,0,0,0,.12-.887l-6.912-9.138a5.627,5.627,0,0,1,.376-7.249h0a5.611,5.611,0,0,1,7.576-.606l.044.046,7.218,10.335a6.435,6.435,0,0,1-.152,10.244l-14.5,11.071a1.911,1.911,0,0,1-1.134.374Z",
    transform: "translate(-463.084 -240.989)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M497.965,224.886v-5.161l9.215-4.025,8.786,4.024v5.161a.847.847,0,0,1-.847.847H498.812a.847.847,0,0,1-.847-.847Z",
    transform: "translate(-449.328 -202.003)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 5.776,
    cy: 5.776,
    r: 5.776,
    transform: "translate(59.958 3.537)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M894.214,208.1a5.773,5.773,0,0,1,6.907-5.664,5.773,5.773,0,1,0-3.587,10.885,5.771,5.771,0,0,1-3.318-5.221Z",
    transform: "translate(-833.811 -201.89)",
    fill: "#2f2e41"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksImage2);
export default __webpack_public_path__ + "static/media/how-it-works-image-2.ae3d4b89756c10f9592eb114e109b35c.svg";
export { ForwardRef as ReactComponent };